module.exports = __webpack_public_path__ + "img/video2.2991879a.png";